export default {
  form: {
    //  操作员号
    operatorNo: '',
    //  邀请渠道
    invitationSource: '',
    //  父级邀请码
    invitationCode: '',
    //  注册渠道
    registerChannel: '',
    //  短信验证 token
    apiTicket: '',
    //  协议编号
    agreementNo: '',
    //  ip
    ip: '',
    deviceType: '',
    loginName: '',
    appId: ''
  },
  header: {
    TermTyp: '',
    deviceId: '',
    appVersion: '',
    osVersion: ''
  },
  isCheckLogin: true,
  isApp: false,
  //  邀请码列表
  invitationList: {
    page: {
      pageNum: 1,
      pageSize: 6,
      pageCount: 0,
      total: 0,
      dataSource: []
    }
  },
  //  我的邀请码
  myInvitationCode: '',
  //  邀请人
  binLoginName: ''
}